/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* MongoDB Atlas project configuration. Applicable if `cloudProvider` is set to `MONGO_ATLAS`. 
*/
export class MongoAtlasSourceAccountAttributesInput {
  /**
  * Public key of the MongoDB Atlas API key with Organization Read Only permissions.
  */
  'apiPublicKey': string;
  /**
  * Private key of the MongoDB Atlas API key.
  */
  'apiPrivateKey': string;
  /**
  * The MongoDB Atlas project ID to onboard.
  */
  'atlasProjectId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "apiPublicKey",
      "baseName": "apiPublicKey",
      "type": "string",
      "format": ""
    },
    {
      "name": "apiPrivateKey",
      "baseName": "apiPrivateKey",
      "type": "string",
      "format": ""
    },
    {
      "name": "atlasProjectId",
      "baseName": "atlasProjectId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return MongoAtlasSourceAccountAttributesInput.attributeTypeMap;
  }

  public constructor() {
  }
}

